let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bEmJF")).then(() => parcelRequire('aShTy'));